module.exports = __webpack_public_path__ + "media/images/athletes/1998-3c484617b254dbede73b1d1ced22c389.png";